
import { Flight } from "@/types/flight";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { FlightBoard } from "@/components/FlightBoard";
import { AirportSelector } from "@/components/AirportSelector";
import { FlightStatusSummary } from "./FlightStatusSummary";

interface FlightTabsProps {
  todaysFlights: Flight[];
  allFlights: Flight[];
}

export function FlightTabs({ todaysFlights, allFlights }: FlightTabsProps) {
  console.log('FlightTabs - todaysFlights:', todaysFlights);
  console.log('FlightTabs - todaysFlights length:', todaysFlights?.length || 0);
  console.log('FlightTabs - allFlights length:', allFlights?.length || 0);

  return (
    <main className="bg-primary/10 rounded-lg shadow-sm border overflow-hidden">
      <Tabs defaultValue="all-flights" className="w-full">
        <div className="border-b">
          <TabsList className="grid w-full grid-cols-2 h-12 bg-muted/50">
            <TabsTrigger value="all-flights" className="text-base">
              All Flights ({todaysFlights.length})
            </TabsTrigger>
            <TabsTrigger value="by-airport" className="text-base">
              By Airport
            </TabsTrigger>
          </TabsList>
        </div>
        
        <TabsContent value="all-flights" className="mt-0">
          <FlightStatusSummary flights={todaysFlights} />
          <FlightBoard flights={todaysFlights} />
        </TabsContent>
        
        <TabsContent value="by-airport" className="mt-0 p-6">
          <AirportSelector flights={allFlights} />
        </TabsContent>
      </Tabs>
    </main>
  );
}
